import styled from 'styled-components'

export const StyledDetailPanel = styled.div<{
  $isOpen: boolean
  $width?: string
  $maxWidth?: string
}>`
  position: fixed;
  top: 0;
  right: 0;
  width: ${({ $width }) => $width || '100%'};
  max-width: ${({ $maxWidth }) => $maxWidth || '1200px'};
  height: 100vh;
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: ${({ $isOpen }) =>
    $isOpen ? '-8px 0 32px rgba(0, 0, 0, 0.08)' : 'none'};
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100%')});
  transition:
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: ${({ theme }) => theme.zIndex.modal};
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 90%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 100%;
  }
`

export const StyledDetailPanelHeader = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.medium};
  }
`

export const StyledDetailPanelContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  position: relative;
`

export const StyledDetailPanelFooter = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.medium};
    gap: ${({ theme }) => theme.spacing.small};
    flex-wrap: wrap;
  }
`

export const DetailPanelOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
  z-index: ${({ theme }) => theme.zIndex.modal - 1};
`
